var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsuranceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.9915 10.2266C17.1474 6.2334 13.9067 3.83398 10.4448 3.46191V2.9375C10.4448 2.41895 10.0227 2 9.50032 2C8.97793 2 8.55588 2.41895 8.55588 2.9375V3.46191C5.0821 3.83398 1.87098 6.2334 1.00918 10.2266C0.944248 10.5225 1.26005 10.8506 1.56109 10.5605C3.09581 8.94922 4.73973 9.02539 6.24199 11.6445C6.39841 11.9229 6.68175 11.8965 6.82341 11.6445C7.41959 10.6074 8.14859 9.5 9.50032 9.5C11.2269 9.5 12.1034 11.5156 12.1772 11.6445C12.3189 11.8965 12.6022 11.9229 12.7587 11.6445C14.2639 9.02246 15.9196 8.9668 17.4396 10.5605C17.7436 10.8535 18.0564 10.5225 17.9915 10.2266ZM8.55588 10.8389V14.6562C8.55588 14.9141 8.34338 15.125 8.08366 15.125C7.85345 15.125 7.69407 14.9697 7.638 14.8115C7.46387 14.3223 6.92671 14.0674 6.43383 14.2402C5.94095 14.4131 5.68418 14.9492 5.85831 15.4355C6.18887 16.3701 7.08609 16.9971 8.08366 16.9971C9.38522 16.9971 10.4448 15.9453 10.4448 14.6533V10.8359C10.1762 10.6045 9.86039 10.4375 9.50032 10.4375C9.1373 10.4404 8.83921 10.5781 8.55588 10.8389Z",
    fill: "#0071BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceIcon);
export default __webpack_public_path__ + "static/media/insuranceIcon.b3d3b898.svg";
export { ForwardRef as ReactComponent };